import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-6 h-6" data-id="element-256" />,
    text: '+1.000 personas interesadas'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-257" />,
    text: '6 Tomos completos'
  }, {
    icon: <Gift className="w-6 h-6" data-id="element-258" />,
    text: '6 Bonos incluidos'
  }, {
    icon: <Star className="w-6 h-6 fill-current" data-id="element-259" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-dark-800 border-y border-dark-700 py-8 relative z-20" data-id="element-260">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-262">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center text-center gap-3" data-id="element-263">
              <div className="text-gold-400 bg-dark-900 p-3 rounded-full border border-dark-700 shadow-gold-glow" data-id="element-264">
                {stat.icon}
              </div>
              <span className="font-semibold text-gray-200 text-sm md:text-base" data-id="element-265">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}